import $ from 'jquery' // jQuery

// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {}

if ($('.js-topLoading')[0]) {
  // クッキー処理
  const cookieArray = []
  if (document.cookie !== '') {
    const tmp = document.cookie.split('; ')
    for (let i = 0; i < tmp.length; i++) {
      const data = tmp[i].split('=')
      cookieArray[data[0]] = decodeURIComponent(data[1])
    }
  }
  const acceptCookie = cookieArray['acceptCookie']
  if (!acceptCookie) {
    document.cookie = 'acceptCookie=allready;max-age=' + 60 * 60 * 24 + ';path=/'

    // ローディングアニメーション
    $(window).on('load', function () {
      $('.js-topLoading-container').addClass('active')
      $('.js-topLoading-img').addClass('active')
      $('.js-topLoading-progress').addClass('active')
      setTimeout(function () {
        const obj = $('.js-topLoading-cnt')[0]
        const from = parseFloat(obj.dataset.from || 0)
        const to = parseFloat(obj.dataset.to || 0)
        const duration = parseInt(obj.dataset.duration) || 3000
        animateValue(obj, from, to, duration)
      }, 0)
      setTimeout(function () {
        $('.js-topLoading-splash').addClass('bubble')
      }, 4000)
      setTimeout(function () {
        $('.js-topLoading-splash').addClass('animate')
      }, 4800)
      setTimeout(function () {
        $('.js-topLoading').addClass('fadeOut')
      }, 5500)
      setTimeout(function () {
        $('.js-topLoading').fadeOut(2000)
        // $('.js-topLoading-splash').removeClass('bubble')
      }, 6000)
    })
  } else {
    $('.js-topLoading').hide()
  }
}

// カウントアップ
function animateValue(obj, start, end, duration) {
  let startTimestamp = null
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp
    const progress = Math.min((timestamp - startTimestamp) / duration, 1)
    obj.innerHTML = Math.floor(progress * (end - start) + start)
    if (progress < 1) {
      window.requestAnimationFrame(step)
    }
  }
  window.requestAnimationFrame(step)
}

if (window.matchMedia('(min-width:769px)').matches) {
  $('.js-topWork').on('mouseenter', function () {
    const id = '#' + $(this).data('topwork')
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    $('.js-topWork-img').removeClass('active')
    $(id).addClass('active')
  })
  $('.js-topWork').on('mouseleave', function () {
    $('.js-topWork').removeClass('active')
    $('.js-topWork-img').removeClass('active')
    $('#topWorkDefault').addClass('active')
  })
}
